'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("filter", {
    id: "realty-house_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.247059 0 0 0 0 0.243137 0 0 0 0 0.294118 0 0 0 1.000000 0"
  }))), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.824 21c0 10.494-8.507 19-19 19s-19-8.506-19-19 8.507-19 19-19 19 8.506 19 19",
    fill: "currentColor",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M8.824 23h5V13h-5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.824 12h-6v11h6V12Zm-1.5 1.571v7.858h-3V13.57h3Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M37.824 48h-32V30.586c7.2-6.27 10.174-10.11 16.37-16.586h.144c6.197 6.476 9.886 10.316 15.486 16.586V48",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.687 13h-.83l-.886.926-.966 1.022-1.002 1.07-3.996 4.316-.97 1.034-.622.656a116.138 116.138 0 0 1-7.688 7.393l-.903.79V49h34V30.267l-.846-.945-1.241-1.378-1.208-1.33-1.187-1.297-1.181-1.28-1.528-1.64-2.934-3.11L22.687 13Zm-.415 1.92 6.551 6.864 1.634 1.738 1.522 1.634 1.177 1.275.59.643 1.191 1.307 1.218 1.347 1.05 1.169v16.467H6.441V30.956l-.28.246a118.5 118.5 0 0 0 8.42-8.042l.953-1.008 4.646-5.011 1.319-1.407.772-.815Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M21.324 16.571 37.574 33l3.25-3.286L21.324 10l-19.5 19.714L5.074 33l16.25-16.429"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M41.824 29.61 21.324 9 .824 29.61 5.19 34l16.133-16.218L37.456 34l4.368-4.39Zm-20.5-18.316L39.54 29.61l-2.085 2.097-16.132-16.218L5.19 31.705l-2.085-2.096 18.218-18.315Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M10.824 48h6V36h-6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.824 35h-8v14h8V35Zm-1.6 1.647v10.706h-4.8V36.647h4.8Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M19.824 42h7v-7h-7z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.824 35h-9v8h9v-8Zm-1.637 1.6v4.8H20.46v-4.8h5.727Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M36.9 48c.383-10.45 9.924-12.451 9.924-20.534 0-6.189-5.454-11.18-11.86-10.382-5.474.681-9.519 5.703-9.112 11.155.56 7.503 9.525 10.058 9.896 19.761H36.9",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.404 16.09c-5.722.742-9.978 6.187-9.55 12.157.2 2.789 1.252 4.864 3.574 7.796l1.412 1.737.515.642c2.82 3.571 3.983 6.052 4.12 9.796l.03.782h2.64l.028-.784c.142-4.038 1.392-6.635 4.372-10.299l1.55-1.872c2.616-3.2 3.729-5.453 3.729-8.64 0-6.744-5.653-12.047-12.187-11.342l-.233.028Zm10.842 11.315c0 2.54-.839 4.404-2.91 7.036l-.5.621-1.232 1.484-.263.32c-2.494 3.066-3.892 5.505-4.458 8.562l-.065.376c-.525-3.067-1.913-5.509-4.49-8.722l-1.442-1.772c-2.301-2.857-3.283-4.718-3.46-7.183-.366-5.111 3.29-9.79 8.174-10.423 5.685-.736 10.646 3.849 10.646 9.7Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M39.824 27a3 3 0 1 1-6.001 0 3 3 0 0 1 6 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M36.823 23a4 4 0 1 0 0 7.999 4 4 0 0 0 0-7.999Zm0 1.623a2.377 2.377 0 1 1 .002 4.754 2.377 2.377 0 0 1-.002-4.754Z",
    fill: "#0969AA"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    filter: "url(#realty-house_svg__a)",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#B6B9B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.727.818c2.202 0 3.818 1.207 4.2 3.284l.026.161h2.567v1.574h-4.11l-.005-.782c-.012-1.757-1.019-2.663-2.678-2.663-.934 0-1.744.416-2.222 1.117l-.086.134-.266.449-.526-.063c-1.139-.134-1.8.175-2.187 1.143l-.051.136-.187.53H3.824V4.262h4.268l.075-.141c.646-1.176 1.72-1.719 3.098-1.694l.051.003.038-.049c.753-.937 1.895-1.505 3.17-1.56l.203-.004ZM46.65 8.985v1.573H36.195V8.985zM34.585 8.985v1.573h-1.608V8.985zM31.368 8.985v1.573h-1.609V8.985zM37.948 0c2.31 0 4.551 2.108 5.1 4.144l.03.12h5.79v1.573H41.57l-.002-.785c-.004-1.428-1.891-3.478-3.619-3.478-1.44 0-2.746.892-3.32 2.201l-.065.16-.29.753-.763-.3a1.956 1.956 0 0 0-.713-.149c-.658 0-1.36.457-1.724 1.05l-.069.12-.224.428h-3.63V4.263h2.686c.635-.884 1.674-1.53 2.785-1.593l.176-.005c.148 0 .295.01.442.03l.127.023.03-.055c.883-1.545 2.52-2.587 4.348-2.659L37.948 0ZM26.542 4.263v1.574h-1.61V4.263z"
  }))), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M9 49H0v-1.5h9zM47.25 49h-9v-1.5h9zM50 49h-2v-1.5h2z"
  })));
});
var RealtyHouse = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyHouse = RealtyHouse;